import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { HeaderBackButton } from "../../../components/BackButton";
import { BillingStatusTag } from "../../../components/BillingStatusTag";
import { BILLINGS_PAGE_PATH } from "../../../middleware/routes";
import { getBillingBilling } from "../../../selectors/billing";

import styles from "./BillingHeader.module.scss";

export const BillingHeader: React.FC = () => {
  const { t } = useTranslation();
  const billing = useSelector(getBillingBilling);

  return (
    <div className={styles.controls}>
      <HeaderBackButton
        backTo={BILLINGS_PAGE_PATH}
        title={
          <div className={styles.nameWrapper}>
            <p>
              {t("billingPage.year")} {billing.year}
            </p>
            <BillingStatusTag value={billing.status} />
          </div>
        }
      />
    </div>
  );
};
